const FEEDBACK = "feedback";

export const feedbackKeys = {
	send: [FEEDBACK, "send"] as const,
};
